module.exports = {"360313001":"峡山口街道","360313101":"湘东镇","360313102":"荷尧镇","360313103":"老关镇","360313104":"腊市镇","360313105":"下埠镇","360313106":"排上镇","360313107":"东桥镇","360313108":"麻山镇","360313200":"广寒寨乡","360313201":"白竺乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360313.json
// module id = 1163
// module chunks = 0